<template>
    <b-form-row>
        <b-modal button-size="sm" hide-footer size="xl" :title="prefix + title" v-model="showModal" @hidden="cancelar">
            <b-form>
                <b-col cols="12">
                    <b-row v-if="isEditing">
                        <lg-form-input v-if="comissao && comissao.id" v-model="comissao.descricao" disabled
                            label="Comissão Responsável:*" description=" " cols="12" sm="12" md="12" />
                        <lg-form-input v-else v-model="responsavel.nome" disabled label="Responsável:*" description=" "
                            cols="12" sm="12" md="12" />

                    </b-row>
                    <b-row v-if="!isEditing">

                        <b-col cols="12">
                            <b-form-group>

                                <LgFinderPagePessoa :mostrarComissao="true" :labelComissao="'Comissão Responsável:*'"
                                    id="finderResponsavelModalInventarioItemBemPermanente" v-model="pessoaComissao"
                                    :prefix="prefix + title + ' > '" @onselectComissao="handleSelectComissao"
                                    @onselect="handleSelectResponsavel" label="Responsável:*"
                                    invalid-feedback="Informe um responsável!" :disabled="isEditing" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <LgFinderPageUnidadeAdministrativa
                                    id="finderUnidadeAdministrativaModalInventarioItemBemPermanente"
                                    :prefix="prefix + title + ' > '" v-model="departamento"
                                    @onselect="handleSelectUnidadeAdministrativa" label="Unidade Administrativa:*"
                                    :ornograma="true" @selecionarOrnograma="handleOrnograma"
                                    :codsDepartamentos="form.codsDepartamentos"
                                    invalidFeedback="Informe uma unidade administrativa!" :disabled="isEditing" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <LgFinderPageLocalArmazenamento :apenasAtivos="true"
                                    id="finderLocalArmazenamentoModalInventarioItemBemPermanente"
                                    :prefix="prefix + title + ' > '" @input="handleSelectLocalArmazenamento"
                                    :codsDepartamentos="form.codsDepartamentos"
                                    v-model="localizacao" @close="handleSelectLocalArmazenamento"
                                    :departamento="departamento" label="Localização Física"
                                    invalidFeedback="Informe uma localização física!" :disabled="isEditing" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <b-form-group label="Data da Auditoria:*">
                                <LgFormDate description="" :disabled="isEditing" v-model="form.dataAuditoria"
                                    class="mt-2" style="padding-left: 0px" />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" class="d-flex align-self-center justify-content-start">
                            <b-form-group>
                                <b-form-checkbox :disabled="isEditing" :checked="form.codTipoColetaColetor === 1"
                                    @change="form.codTipoColetaColetor = $event ? 1 : 2">
                                    Tipo Coleta Restrita
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-row class="mb-3 align-items-center" v-if="isEditing">
                    <b-col cols="12" md="6">
                        <b-form-group label="Ordenar itens por:">
                            <b-form-select v-model="sortOption" :options="sortOptions" size="sm" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="legend d-flex flex-wrap">
                            <span class="legend-item legend-read-ok">Lidos sem divergência</span>
                            <span class="legend-item legend-read-divergence">Lidos com divergência</span>
                            <span class="legend-item legend-unread">Não lidos</span>
                        </div>
                    </b-col>
                </b-row>
                <div class="table-container position-relative">
                    <div v-if="isSorting"
                        class="sorting-overlay d-flex flex-column align-items-center justify-content-center">
                        <b-spinner class="mb-2" />
                        <span>Aplicando ordenação...</span>
                    </div>
                    <b-table :items="displayedItems" :fields="itemsTableFields" :busy.sync="busy"
                        @row-selected="onRowSelected" :tbody-tr-class="getRowClass" selectable select-mode="single"
                        :sticky-header="true" :head-variant="primary" :foot-clone="false"
                        style="max-height: 400px !important; overflow-y: auto !important" @scroll.native="onScroll"
                        show-empty>

                        <template #cell(status)="data">
                            <b-badge v-for="badge in getStatusBadges(data.item)" :key="badge.key" pill
                                :variant="badge.variant" class="mr-1">
                                {{ badge.text }}
                            </b-badge>
                        </template>

                        <template #cell(emDivergencia)="data">
                            <b-badge v-if="hasDivergenceBadge(data.item)" variant="danger" pill>
                                Em divergência
                            </b-badge>
                            <span v-else>Sem divergência</span>
                        </template>

                        <template #cell(descricao)="data">

                            {{ data.item.itemRegEntrada &&
                                data.item.itemRegEntrada.produto ? data.item.itemRegEntrada.produto.descricaoResumida :
                                data.item.descricaoResumida }}
                        </template>


                        <template #empty>
                            <p class="text-center">Nenhum registro encontrado</p>
                        </template>

                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle" />
                            </div>
                        </template>

                        <template #cell(ancora)="row">
                            <span v-if="row.index === itemsTable.length - 1" ref="scrollAnchor"></span>
                        </template>
                    </b-table>
                </div>
                <div v-if="loadingMore" class="d-flex align-items-center justify-content-center py-2">
                    <b-spinner small class="mr-2" />
                    <span>Carregando novos itens...</span>
                </div>
                <div v-for="(item) in itemsTable" :key="item.codItemBemPermanente">
                    <b-collapse :id="`divergence-${item.codItemBemPermanente}`" :visible="item.showDivergence">
                        <b-card>
                            <b-row>
                                <b-col cols="9">
                                    <b-form-group label="Divergências">
                                        <b-row>
                                            <b-col cols="3">
                                                <b-form-checkbox v-model="item.divergences.naoLocalizado"
                                                    @change="onNaoLocalizadoChange(item)">
                                                    Não localizado
                                                </b-form-checkbox>
                                            </b-col>
                                            <b-col cols="9" class="d-flex justify-content-start">
                                                <b-form-checkbox v-model="item.divergences.transferidoParaDeposito"
                                                    :disabled="!item.divergences.naoLocalizado" class="mr-3">
                                                    Transferir para o depósito
                                                </b-form-checkbox>
                                                <b-form-checkbox v-model="item.divergences.emApuracao"
                                                    :disabled="!item.divergences.naoLocalizado">
                                                    Bem em apuração
                                                </b-form-checkbox>
                                            </b-col>
                                        </b-row>
                                        <!-- Item Baixado -->
                                        <b-row>
                                            <b-col cols="3">
                                                <b-form-checkbox v-model="item.divergences.itemBaixado"
                                                    @change="onItemBaixadoChange(item)">
                                                    Item baixado
                                                </b-form-checkbox>
                                            </b-col>
                                            <b-col cols="9" class="d-flex justify-content-start">
                                                <b-form-radio-group v-model="item.divergences.solucaoItemBaixado"
                                                    :options="solucaoItemBaixadoOptions"
                                                    :disabled="!item.divergences.itemBaixado"
                                                    class="mr-3"></b-form-radio-group>
                                            </b-col>
                                        </b-row>
                                        <!-- Item de Outra Lotação -->
                                        <b-row>
                                            <b-col cols="3">
                                                <b-form-checkbox v-model="item.divergences.itemOutraLotacao"
                                                    @change="onItemOutraLotacaoChange(item)">
                                                    Item de outra Lotação
                                                </b-form-checkbox>
                                            </b-col>
                                            <b-col cols="9" class="d-flex justify-content-start">
                                                <b-form-radio-group v-model="item.divergences.solucaoItemOutraLotacao"
                                                    :options="solucaoItemOutraLotacaoOptions"
                                                    :disabled="!item.divergences.itemOutraLotacao"
                                                    class="mr-3"></b-form-radio-group>
                                                <LgFinderPageUnidadeAdministrativa
                                                    id="finderUnidadeAdministrativaDestino"
                                                    v-model="item.divergences.departamentoDestino"
                                                    :prefix="prefix + title + ' > '"
                                                    @onselect="handleSelectUnidadeAdministrativaDestino(item, $event)"
                                                    label="Departamento:"
                                                    :disabled="!item.divergences.itemOutraLotacao || item.divergences.solucaoItemOutraLotacao !== 1" />
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="3">
                                                <b-form-checkbox v-model="item.divergences.localFisicoIncorreto"
                                                    @change="onLocalFisicoIncorretoChange(item)">
                                                    Local físico incorreto
                                                </b-form-checkbox>
                                            </b-col>
                                            <b-col cols="9" class="d-flex justify-content-start">
                                                <b-form-radio-group
                                                    v-model="item.divergences.solucaoLocalFisicoIncorreto"
                                                    :options="solucaoLocalFisicoIncorretoOptions"
                                                    :disabled="!item.divergences.localFisicoIncorreto"
                                                    class="mr-3"></b-form-radio-group>

                                                <LgFinderPageLocalArmazenamento :apenasAtivos="true"
                                                    id="finderLocalArmazenamentoDestinoUnico"
                                                    :prefix="prefix + title + ' > '"
                                                    @input="handleSelectLocalDestino(item, $event)"
                                                    v-model="item.divergences.localDestino"
                                                    @close="handleSelectLocalDestino(item, $event)" label="Localização:"
                                                    :disabled="!item.divergences.localFisicoIncorreto || item.divergences.solucaoLocalFisicoIncorreto !== 1" />
                                            </b-col>
                                        </b-row>
                                        <!-- Conservação Incorreta -->
                                        <b-row>
                                            <b-col cols="5">
                                                <b-form-checkbox class="mt-2"
                                                    v-model="item.divergences.conservacaoIncorreta"
                                                    @change="onConservacaoIncorretaChange(item)">
                                                    Estado de Conservação incorreto
                                                </b-form-checkbox>
                                            </b-col>
                                            <b-col cols="7" class="d-flex justify-content-start">
                                                <b-button v-if="item.divergences.conservacaoIncorreta"
                                                    @click="showConservacaoModal(item)" variant="link">
                                                    Preencher dados de conservação
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-collapse>
                </div>
                <b-modal v-model="mostrarModalConservacao" id="conservacaoModal" ref="conservacaoModal" hide-footer
                    :title="prefix + title + ' > Estado de Conservação'" @hide="resetConservacaoData">
                    <b-form>
                        <LgFinderPagePessoa id="finderPessoaConservacaoModal" @onselect="handleConservacaoPessoa"
                            v-model="conservacaoData.pessoa" :prefix="prefix + title + ' > '" label="Responsável*:" />
                        <LgFinderPageTipoEstado id="finderTipoEstadoConservacaoModal" @onselect="handleTipoEstado"
                            v-model="conservacaoData.tipoEstado" :prefix="[prefix, title]" label="Tipo de Estado*:" />
                        <b-form-group label="Descrição*:">
                            <b-form-textarea v-model="conservacaoData.descricao"></b-form-textarea>
                        </b-form-group>
                        <b-form-group label="Data de Avaliação*:">
                            <LgFormDate v-model="conservacaoData.dataAvaliacao" description="" />
                        </b-form-group>

                        <b-form-row>

                            <b-col cols="3"></b-col>
                            <b-col cols="6" class="text-center">
                                <b-button id="salvarInventario" class=" my-2" size="sm" pill variant="success"
                                    @click="saveConservacaoData">
                                    <b-icon icon="check-circle" />
                                    <b-tooltip target="salvarInventario" title="Salvar"></b-tooltip>

                                </b-button>

                                <b-button id="cancelarInventario" class=" my-2 ml-2" size="sm" pill variant="danger"
                                    @click="resetConservacaoData">
                                    <b-icon icon="x-circle" />
                                    <b-tooltip target="cancelarInventario" title="Cancelar"></b-tooltip>

                                </b-button>
                            </b-col>
                            <b-col cols="3"></b-col>

                        </b-form-row>


                    </b-form>
                </b-modal>

                <b-form-row>

                    <b-col cols="3"></b-col>
                    <b-col cols="6" class="text-center">
                        <b-button id="salvarInventarioConserv" class=" my-2" size="sm" pill variant="success"
                            @click="save">
                            <b-icon icon="check-circle" />
                            <b-tooltip target="salvarInventarioConserv" title="Salvar"></b-tooltip>

                        </b-button>

                        <b-button id="cancelarInventarioConserv" class=" my-2 ml-2" size="sm" pill variant="danger"
                            @click="cancelar">
                            <b-icon icon="x-circle" />
                            <b-tooltip target="cancelarInventarioConserv" title="Cancelar"></b-tooltip>

                        </b-button>
                    </b-col>
                    <b-col cols="3"></b-col>

                </b-form-row>

            </b-form>

        </b-modal>
    </b-form-row>
</template>

<script>
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFinderPageTipoEstado from "@/components/Finders/LgFinderPageTipoEstadoConservacao.vue";
import AuditoriaItemBemPermanenteService from "@/core/api/AuditoriaItemBemPermanenteService.js";
import Swal from "sweetalert2";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";

export default {
    name: "InventarioItemBemPermanenteForm",
    components: {
        LgFormInput,
        LgFinderPagePessoa,
        LgFinderPageUnidadeAdministrativa,
        LgFinderPageLocalArmazenamento,
        LgFormDate,
        LgFinderPageTipoEstado,
    },
    props: {
        codSolicitacaoInventario: {
            type: Number,
            default: null,
        },
        auditoria: {
            type: Object,
            default: null

        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Cadastro"
        }
    },

    data() {
        return {
            usandoOrnograma: false,
            mostrarModalConservacao: false,
            showModal: true,
            isEditing: this.auditoria != null,
            form: {
                id: null,
                codsDepartamentos: "",
                dataAuditoria: null,
                codPessoa: null,
                codComissao: null,
                codDepartamento: null,
                codLocalizacao: null,
                codTipoColetaColetor: null,
                finalizado: false,
                itens: [],
            },
            responsavel: { nome: "" },
            comissao: null,
            pessoaComissao: null,
            departamento: null,
            localizacao: null,
            departamentoDestinoDivergencia: null,
            localDestinoDivergencia: null,
            itemsTable: [],
            totalItems: 0,
            busy: false,
            page: 0,
            size: 20,
            loadingMore: false,
            noMoreItems: false,
            isFetchingItems: false,
            prefetchingItems: false,
            prefetchedQueue: [],
            pendingScrollLoad: false,
            allItemsPrefetched: false,
            fetchVersion: 0,
            sortOption: "default",
            sortOptions: [
                { value: "default", text: "Ordenação padrão" },
                { value: "lidos", text: "Itens lidos" },
                { value: "lidos_divergencia", text: "Itens lidos com divergência" },
                { value: "nao_lidos", text: "Itens não lidos" },
            ],
            nextInsertIndex: 0,
            isSorting: false,
            conservacaoData: {
                pessoa: null,
                tipoEstado: null,
                descricao: "",
                dataAvaliacao: null,
            },
            selectedConservacaoItem: null,
            solucaoItemBaixadoOptions: [
                { text: "Descartar", value: 1 },
                { text: "Ativar", value: 2 },
            ],
            solucaoItemOutraLotacaoOptions: [
                { text: "Devolver", value: 2 },
                { text: "Transferir", value: 1 },
            ],
            solucaoLocalFisicoIncorretoOptions: [
                { text: "Devolver", value: 2 },
                { text: "Transferir", value: 1 },
            ],
            primary: "#063662",
        };
    },
    computed: {

        itemsTableFields() {
            var cabecalho = [];

            if (this.usandoOrnograma)
                cabecalho.push({ key: "departamento", label: "Departamento" });

            cabecalho.push({ key: "numTombamento", label: "Nro Tombamento" });
            cabecalho.push({ key: "descricao", label: "Descrição" });
            cabecalho.push({ key: "numSerie", label: "Nro de Série" });
            cabecalho.push({ key: "status", label: "Status" });
            cabecalho.push({ key: "emDivergencia", label: "Em Divergência" });
            cabecalho.push({ key: 'ancora', label: '', });

            return cabecalho;
        },

        displayedItems() {
            if (!Array.isArray(this.itemsTable)) {
                return [];
            }

            const items = this.itemsTable.slice();

            if (this.sortOption === "default") {
                return items;
            }

            const compareByFlag = (extractor) => (a, b) => {
                const flagsA = this.getItemStatusFlags(a);
                const flagsB = this.getItemStatusFlags(b);
                const aValue = extractor(flagsA) ? 1 : 0;
                const bValue = extractor(flagsB) ? 1 : 0;

                if (aValue === bValue) {
                    const indexA = typeof a.__insertIndex === "number" ? a.__insertIndex : 0;
                    const indexB = typeof b.__insertIndex === "number" ? b.__insertIndex : 0;
                    return indexA - indexB;
                }

                return bValue - aValue;
            };

            if (this.sortOption === "lidos") {
                return items.sort(compareByFlag((flags) => flags.isRead && !flags.isReadWithDivergence));
            }

            if (this.sortOption === "lidos_divergencia") {
                return items.sort(compareByFlag((flags) => flags.isReadWithDivergence));
            }

            if (this.sortOption === "nao_lidos") {
                return items.sort(compareByFlag((flags) => flags.naoLocalizado));
            }

            return items;
        }
    },
    watch: {
        async sortOption(newValue, oldValue) {
            if (newValue === oldValue || newValue === "default") {
                return;
            }
            this.isSorting = true;
            await this.ensureAllItemsLoaded();
            this.isSorting = false;
        },
    },
    methods: {
        normalizeBoolean(value) {
            if (value === null || value === undefined) {
                return false;
            }

            if (typeof value === "boolean") {
                return value;
            }

            if (typeof value === "number") {
                return value !== 0;
            }

            if (typeof value === "string") {
                const normalized = value.trim().toLowerCase();
                return ["1", "true", "t", "sim", "s"].includes(normalized);
            }

            return Boolean(value);
        },
        computeStatusFlags(item) {
            if (!item) {
                return {
                    isRead: false,
                    isReadWithDivergence: false,
                    hasDivergence: false,
                    naoLocalizado: false,
                };
            }

            const divergences = item.divergences || {};

            const naoLocalizado = this.normalizeBoolean(
                item.naoLocalizado != null
                    ? item.naoLocalizado
                    : divergences.naoLocalizado,
            );

            const localizadoLotacaoDiferente = this.normalizeBoolean(
                item.localizadoLotacaoDiferente != null
                    ? item.localizadoLotacaoDiferente
                    : item.itemOutraLotacao != null
                        ? item.itemOutraLotacao
                        : divergences.itemOutraLotacao,
            );

            const itemBaixado = this.normalizeBoolean(
                item.itemBaixado != null
                    ? item.itemBaixado
                    : divergences.itemBaixado,
            );

            const baseDivergence =
                this.normalizeBoolean(item.emDivergencia) ||
                this.normalizeBoolean(divergences.emApuracao) ||
                this.normalizeBoolean(divergences.transferidoParaDeposito) ||
                this.normalizeBoolean(divergences.localFisicoIncorreto) ||
                this.normalizeBoolean(divergences.conservacaoIncorreta);

            const isRead = !naoLocalizado;

            const hasDivergence =
                localizadoLotacaoDiferente ||
                itemBaixado ||
                (!naoLocalizado && baseDivergence);

            return {
                isRead,
                isReadWithDivergence: isRead && hasDivergence,
                hasDivergence: hasDivergence || naoLocalizado,
                naoLocalizado,
                itemBaixado,
                localizadoLotacaoDiferente,
            };
        },
        buildStatusBadges(flags) {
            const badges = [];

            if (flags.naoLocalizado) {
                badges.push({
                    key: "nao-lido",
                    text: "Não lido",
                    variant: "warning",
                });
                return badges;
            }

            if (flags.isReadWithDivergence) {
                badges.push({
                    key: "lido-divergencia",
                    text: "Lido com divergência",
                    variant: "danger",
                });
                return badges;
            }

            if (flags.isRead) {
                badges.push({
                    key: "lido",
                    text: "Lido",
                    variant: "success",
                });
                return badges;
            }

            return [
                {
                    key: "indefinido",
                    text: "Status indefinido",
                    variant: "secondary",
                },
            ];
        },
        applyStatusMetadata(item) {
            const flags = this.computeStatusFlags(item);
            const badges = this.buildStatusBadges(flags);

            this.$set(item, "__statusFlags", flags);
            this.$set(item, "__statusBadges", badges);
        },
        getItemStatusFlags(item) {
            if (!item) {
                return {
                    isRead: false,
                    isReadWithDivergence: false,
                    hasDivergence: false,
                    naoLocalizado: false,
                    itemBaixado: false,
                    localizadoLotacaoDiferente: false,
                };
            }

            if (!item.__statusFlags) {
                this.applyStatusMetadata(item);
            }

            return item.__statusFlags;
        },
        getStatusBadges(item) {
            if (!item) {
                return [];
            }

            if (!item.__statusBadges) {
                this.applyStatusMetadata(item);
            }

            return item.__statusBadges;
        },
        hasDivergenceBadge(item) {
            const flags = this.getItemStatusFlags(item);
            return flags.hasDivergence;
        },
        getRowClass(item) {
            if (!item) {
                return "";
            }

            if (!item.__statusFlags) {
                this.applyStatusMetadata(item);
            }

            const flags = item.__statusFlags;

            if (flags.naoLocalizado) {
                return "row-unread";
            }

            if (flags.isReadWithDivergence) {
                return "row-read-divergence";
            }

            if (flags.isRead) {
                return "row-read-ok";
            }

            return "";
        },
        handleConservacaoPessoa(item) {
            this.conservacaoData.pessoa = item;
        },
        handleTipoEstado(item) {
            this.conservacaoData.tipoEstado = item;
        },
        cancelar() {
            this.$emit("close");
        },

        resetForm() {
            this.resetPaginationState();
            this.form = {
                id: null,
                dataAuditoria: null,
                codPessoa: null,
                codComissao: null,
                codDepartamento: null,
                codLocalizacao: null,
                codTipoColetaColetor: 2,
                itens: [],
            };
            this.responsavel = null;
            this.departamento = null;
            this.localizacao = null;
            this.itemsTable = [];
            this.busy = false;
            this.conservacaoData = {
                pessoa: null,
                tipoEstado: null,
                descricao: "",
                dataAvaliacao: null,
            };
        },
        resetPaginationState() {
            this.page = 0;
            this.noMoreItems = false;
            this.loadingMore = false;
            this.isFetchingItems = false;
            this.prefetchingItems = false;
            this.prefetchedQueue = [];
            this.pendingScrollLoad = false;
            this.allItemsPrefetched = false;
            this.fetchVersion += 1;
            this.nextInsertIndex = 0;
        },
        checkDivergencia(item) {
            const hasDivergencia =
                item.divergences.naoLocalizado ||
                item.divergences.emApuracao ||
                item.divergences.transferidoParaDeposito ||
                item.divergences.itemBaixado ||
                item.divergences.itemOutraLotacao ||
                item.divergences.localFisicoIncorreto ||
                item.divergences.conservacaoIncorreta;

            item.emDivergencia = hasDivergencia;
            item.naoLocalizado = item.divergences.naoLocalizado;
            item.itemBaixado = item.divergences.itemBaixado;
            item.localizadoLotacaoDiferente = item.divergences.itemOutraLotacao;

            this.applyStatusMetadata(item);
        },
        async save() {

            if (!this.pessoaComissao || !this.pessoaComissao.id) {
                this.$notify({
                    type: "danger",
                    message: `É necessário informar o responsável`,
                });
                return;
            }

            if ((!this.departamento || !this.departamento.id) && !this.form.codsDepartamentos) {
                this.$notify({
                    type: "danger",
                    message: `É necessário informar a Unidade Administrativa`,
                });
                return;
            }

            if (!this.form.dataAuditoria) {
                this.$notify({
                    type: "danger",
                    message: `É necessário informar a data de auditoria`,
                });
                return;
            }

            this.form.finalizado = false;

            var erro = false;

            this.itemsTable.forEach(item => {


                if (item.divergences.conservacaoIncorreta && ((!item.divergences.conservacaoData) || (!item.divergences.conservacaoData.pessoa || !item.divergences.conservacaoData.pessoa.id)
                    || (item.divergences.conservacaoData.descricao == '') || (!item.divergences.conservacaoData.dataAvaliacao) || (!item.divergences.conservacaoData.tipoEstado || !item.divergences.conservacaoData.tipoEstado.id)
                )) {
                    erro = true;
                }

            })


            if (erro) {
                this.$notify({
                    type: "danger",
                    message: `Preencha os dados da Conservação corretamente`,
                });
                return;

            }

            const auditoriaData = {
                ...this.form,
                itens: this.itemsTable
                    .filter((item) => item.emDivergencia)
                    .map((item) => ({
                        codAuditoriaItemBemPermanente: this.form.id,
                        codItemBemPermanente: item.codItemBemPermanente,
                        emDivergencia: item.emDivergencia,
                        naoLocalizado: item.divergences.naoLocalizado,
                        emApuracao: item.divergences.emApuracao,
                        transferidoParaDeposito: item.divergences.transferidoParaDeposito,
                        itemBaixado: item.divergences.itemBaixado,
                        solucaoItemBaixado: item.divergences.solucaoItemBaixado,
                        localizadoLotacaoDiferente: item.divergences.itemOutraLotacao,
                        solucaoLocalizadoLotacaoDiferente: item.divergences.solucaoItemOutraLotacao,
                        departamentoDestinoId: item.divergences.itemOutraLotacao && item.divergences.solucaoItemOutraLotacao === 1 ? item.divergences.departamentoDestino.id : null,

                        localizadoLocalFisicoDiferente: item.divergences.localFisicoIncorreto,
                        solucaoLocalizadoLocalFisicoDiferente: item.divergences.solucaoLocalFisicoIncorreto,
                        localDestinoId: item.divergences.localFisicoIncorreto && item.divergences.solucaoLocalFisicoIncorreto === 1 ? item.divergences.localDestino.id : null,

                        estadoConservacaoDiferente: item.divergences.conservacaoIncorreta,

                        tipoEstadoConservacaoNovoId: item.divergences.conservacaoIncorreta ? item.divergences.conservacaoData.tipoEstado.id : null,
                        descricaoEstadoConservacaoNovo: item.divergences.conservacaoIncorreta ? item.divergences.conservacaoData.descricao : null,
                        dataEstadoConservacaoNovo: item.divergences.conservacaoIncorreta ? item.divergences.conservacaoData.dataAvaliacao : null,
                        pessoaEstadoConservacaoNovoId: item.divergences.conservacaoIncorreta ? item.divergences.conservacaoData.pessoa.id : null,

                        justificativaEstornoBaixa: item.divergences.itemBaixado ? item.divergences.justificativaEstornoBaixa : null
                    })),
            };
            try {
                if (this.isEditing) {
                    this.busy = true;
                    await AuditoriaItemBemPermanenteService.atualizarAuditoria(
                        this.form.id,
                        auditoriaData,
                    );
                    Swal.fire("Sucesso", "Inventário atualizado com sucesso.", "success");
                    this.busy = false;

                    this.cancelar();
                } else {
                    this.busy = true;

                    auditoriaData.codSolicitacaoInventario = this.codSolicitacaoInventario;
                    await AuditoriaItemBemPermanenteService.criarAuditoria(auditoriaData);
                    Swal.fire("Sucesso", "Inventário criado com sucesso.", "success");
                    this.busy = false;

                    this.cancelar();

                }
            } catch (error) {
                Swal.fire("Erro", "Ocorreu um erro ao salvar o inventário.", error);
            }
        },
        async saveConservacaoData() {


            if ((!this.conservacaoData.pessoa || !this.conservacaoData.pessoa.id)
                || (this.conservacaoData.descricao == '') || (!this.conservacaoData.dataAvaliacao) || (!this.conservacaoData.tipoEstado || !this.conservacaoData.tipoEstado.id)
            ) {
                this.$notify({
                    type: "danger",
                    message: `Preencha os dados corretamente`,
                });
                return;
            }

            this.selectedConservacaoItem.divergences.conservacaoData = {
                ...this.conservacaoData,
            };

            this.mostrarModalConservacao = false;
        },
        async loadItems(options = {}) {
            const { silent = false } = options;

            if (this.noMoreItems) {
                return false;
            }

            if (!this.isEditing && (!this.form.codDepartamento && !this.form.codsDepartamentos)) {
                return false;
            }

            const currentVersion = this.fetchVersion;

            if (silent) {
                if (this.prefetchingItems || this.isFetchingItems) {
                    return false;
                }
                this.prefetchingItems = true;
            } else {
                this.pendingScrollLoad = false;
                if (this.isFetchingItems) {
                    return false;
                }
                this.isFetchingItems = true;
                if (this.page === 0) {
                    this.busy = true;
                } else {
                    this.loadingMore = true;
                }
            }

            let loadedItems = [];
            let shouldSchedulePrefetch = false;

            try {
                let response;

                if (this.isEditing) {
                    response = await AuditoriaItemBemPermanenteService.getProximosItensDaAuditoria(
                        this.form.id,
                        this.page,
                        this.size,
                    );
                } else {
                    const params = {
                        codsDepartamentos: this.form.codsDepartamentos,
                        codDepartamento: this.form.codDepartamento,
                        codLocalizacao: this.form.codLocalizacao,
                        page: this.page,
                        size: this.size,
                    };
                    response = await AuditoriaItemBemPermanenteService.getItemsByDepartamentoAndLocalizacao(params);
                }

                if (currentVersion !== this.fetchVersion) {
                    return false;
                }

                const data = (response && response.data) || {};
                const content = Array.isArray(data.content) ? data.content : [];

                if (content.length === 0) {
                    this.noMoreItems = true;
                    this.allItemsPrefetched = true;
                    this.pendingScrollLoad = false;
                    this.loadingMore = false;
                    return false;
                }

                loadedItems = content.map((item) => {
                    if (this.isEditing) {
                        const rawOutraLotacao = item.localizadoLotacaoDiferente != null
                            ? item.localizadoLotacaoDiferente
                            : item.itemOutraLotacao;

                        const rawSolucaoOutraLotacao = item.solucaoLocalizadoLotacaoDiferente != null
                            ? item.solucaoLocalizadoLotacaoDiferente
                            : item.solucaoItemOutraLotacao;

                        const rawItemBaixado = item.itemBaixado != null
                            ? item.itemBaixado
                            : item.baixado;

                        const mappedItem = {
                            ...item.itemBemPermanente,
                            emDivergencia: this.normalizeBoolean(item.emDivergencia),
                            naoLocalizado: this.normalizeBoolean(item.naoLocalizado),
                            localizadoLotacaoDiferente: this.normalizeBoolean(rawOutraLotacao),
                            itemBaixado: this.normalizeBoolean(rawItemBaixado),
                            codItemBemPermanente: item.codItemBemPermanente,
                            codAuditoriaItemBemPermanente: this.form.id,
                            divergences: {
                                conservacaoData: {
                                    pessoa: item.pessoaEstadoConservacaoNovo,
                                    descricao: item.descricaoEstadoConservacaoNovo,
                                    dataAvaliacao: item.dataEstadoConservacaoNovo,
                                    tipoEstado: item.tipoEstadoConservacaoNovo,
                                },
                                itemOutraLotacao: this.normalizeBoolean(rawOutraLotacao),
                                solucaoItemOutraLotacao: rawSolucaoOutraLotacao,
                                naoLocalizado: this.normalizeBoolean(item.naoLocalizado),
                                transferidoParaDeposito: this.normalizeBoolean(item.transferidoParaDeposito),
                                emApuracao: this.normalizeBoolean(item.emApuracao),
                                itemBaixado: this.normalizeBoolean(rawItemBaixado),
                                solucaoItemBaixado: item.solucaoItemBaixado || null,
                                departamentoDestinoId: item.departamentoDestino ? item.departamentoDestino.id : null,
                                departamentoDestino: item.departamentoDestino || null,
                                localFisicoIncorreto: this.normalizeBoolean(item.localizadoLocalFisicoDiferente),
                                solucaoLocalFisicoIncorreto: item.solucaoLocalizadoLocalFisicoDiferente || null,
                                localDestino: item.localDestino || null,
                                localDestinoId: item.localDestino ? item.localDestino.id : null,
                                conservacaoIncorreta: this.normalizeBoolean(item.estadoConservacaoDiferente),
                            },
                            showDivergence: false,
                        };

                        mappedItem.__insertIndex = this.nextInsertIndex++;
                        this.applyStatusMetadata(mappedItem);
                        return mappedItem;
                    }

                    const mappedItem = {
                        ...item,
                        codItemBemPermanente: item.id,
                        emDivergencia: false,
                        naoLocalizado: this.normalizeBoolean(item.naoLocalizado),
                        localizadoLotacaoDiferente: this.normalizeBoolean(item.localizadoLotacaoDiferente),
                        itemBaixado: this.normalizeBoolean(item.itemBaixado),
                        divergences: {
                            naoLocalizado: false,
                            transferidoParaDeposito: false,
                            emApuracao: false,
                            itemBaixado: false,
                            solucaoItemBaixado: null,
                            itemOutraLotacao: false,
                            solucaoItemOutraLotacao: null,
                            departamentoDestino: null,
                            localFisicoIncorreto: false,
                            solucaoLocalFisicoIncorreto: null,
                            localDestino: null,
                            conservacaoIncorreta: false,
                        },
                        showDivergence: false,
                    };

                    mappedItem.__insertIndex = this.nextInsertIndex++;
                    this.applyStatusMetadata(mappedItem);
                    return mappedItem;
                });

                if (silent) {
                    this.prefetchedQueue.push(loadedItems);
                    if (this.pendingScrollLoad && this.prefetchedQueue.length > 0) {
                        this.flushPrefetchedQueue();
                    }
                    if (!this.noMoreItems) {
                        shouldSchedulePrefetch = true;
                    }
                } else {
                    this.itemsTable = [...this.itemsTable, ...loadedItems];
                    if (!this.noMoreItems) {
                        shouldSchedulePrefetch = true;
                    }
                }

                this.page += 1;

                if (data.totalPages !== undefined && data.totalPages !== null) {
                    if (this.page >= data.totalPages) {
                        this.noMoreItems = true;
                        this.allItemsPrefetched = true;
                    } else {
                        this.allItemsPrefetched = false;
                    }
                }

                return loadedItems.length > 0;
            } catch (error) {
                console.error("Erro ao carregar itens da auditoria:", error);
                if (silent && this.pendingScrollLoad) {
                    this.pendingScrollLoad = false;
                    this.loadingMore = false;
                }
                this.$notify({
                    type: "danger",
                    message: "Não foi possível carregar os itens da auditoria.",
                });
                return false;
            } finally {
                if (silent) {
                    this.prefetchingItems = false;
                } else {
                    this.isFetchingItems = false;
                    this.busy = false;
                    this.loadingMore = false;
                }

                if (shouldSchedulePrefetch) {
                    this.scheduleNextPrefetch();
                }
            }
        },
        onScroll(event) {
            const tableBody = event.target;
            if (
                tableBody.scrollTop + tableBody.clientHeight >=
                tableBody.scrollHeight - 10
            ) {
                if (this.prefetchedQueue.length > 0) {
                    this.flushPrefetchedQueue();
                } else if (!this.noMoreItems) {
                    if (this.prefetchingItems) {
                        this.pendingScrollLoad = true;
                        this.loadingMore = true;
                    } else if (!this.isFetchingItems) {
                        this.loadingMore = true;
                        this.loadItems().then(() => {
                            this.$nextTick(() => {
                                const el = this.$refs.scrollAnchor;
                                if (el && el.scrollIntoView) {
                                    el.scrollIntoView({ behavior: 'smooth', block: 'end' });
                                }
                            });
                        });
                    }
                }
            }
        },
        handleSelectResponsavel(responsavel) {
            this.responsavel = responsavel;
            this.form.codPessoa = responsavel ? responsavel.id : null;
            this.pessoaComissao = responsavel;

            this.form.codComissao = null;
            this.comissao = null;


        },
        handleSelectComissao(comissao) {
            this.comissao = comissao;
            this.pessoaComissao = comissao;
            this.form.codComissao = comissao ? comissao.id : null;

            this.responsavel = null;
            this.form.codPessoa = null;

        },
        handleOrnograma(ornograma) {
            this.usandoOrnograma = true;
            this.form.codsDepartamentos = ornograma;
            this.form.codDepartamento = null;
            this.itemsTable = [];
            this.resetPaginationState();
            this.loadItems();

        },
        handleSelectUnidadeAdministrativa(departamento) {
            this.usandoOrnograma = false;
            this.form.codsDepartamentos = "";
            this.departamento = departamento;
            this.form.codDepartamento = departamento ? departamento.id : null;
            this.itemsTable = [];
            this.resetPaginationState();
            this.loadItems();
        },
        handleSelectLocalArmazenamento(localizacao) {
            this.localizacao = localizacao;
            this.form.codLocalizacao = localizacao ? localizacao.id : null;
            this.itemsTable = [];
            this.resetPaginationState();
            this.loadItems();
        },
        handleSelectUnidadeAdministrativaDestino(item, unidadeSelecionada) {
            this.itemsTable = !this.itemsTable || this.itemsTable.length == 0 ? [] : this.itemsTable.map((i) => {
                if (i.codItemBemPermanente === item.codItemBemPermanente) {
                    i.divergences.departamentoDestino = unidadeSelecionada;
                }
                return i;
            });
        },

        handleSelectLocalDestino(item, localSelecionado) {
            this.itemsTable = !this.itemsTable == this.itemsTable.length == 0 ? [] : this.itemsTable.map((i) => {
                if (i.codItemBemPermanente === item.codItemBemPermanente) {
                    i.divergences.localDestino = localSelecionado;
                }
                return i;
            });
        },
        async ensureAllItemsLoaded() {
            const shouldToggleLoading = !this.loadingMore;
            if (shouldToggleLoading) {
                this.loadingMore = true;
            }

            let safetyCounter = 0;
            const MAX_ITERATIONS = 1000;

            while (safetyCounter < MAX_ITERATIONS) {
                safetyCounter += 1;

                if (this.prefetchedQueue.length > 0) {
                    this.flushPrefetchedQueue();
                    continue;
                }

                if (this.noMoreItems && !this.prefetchingItems && !this.isFetchingItems) {
                    break;
                }

                if (!this.noMoreItems && !this.prefetchingItems && !this.isFetchingItems) {
                    await this.loadItems({ silent: true });
                    continue;
                }

                await this.waitForIdle();
            }

            if (shouldToggleLoading) {
                this.loadingMore = false;
            }
        },
        waitForIdle() {
            return new Promise((resolve) => {
                const check = () => {
                    if (!this.isFetchingItems && !this.prefetchingItems) {
                        this.$nextTick(resolve);
                    } else {
                        setTimeout(check, 50);
                    }
                };
                check();
            });
        },
        scheduleNextPrefetch() {
            if (this.noMoreItems || this.prefetchingItems || this.isFetchingItems) {
                return;
            }
            this.$nextTick(() => {
                this.loadItems({ silent: true }).catch(() => {
                    /* erros já tratados em loadItems */
                });
            });
        },
        flushPrefetchedQueue() {
            if (!this.prefetchedQueue.length) {
                return false;
            }

            const nextItems = this.prefetchedQueue.shift();
            if (Array.isArray(nextItems) && nextItems.length > 0) {
                this.itemsTable = [...this.itemsTable, ...nextItems];
            }

            this.loadingMore = false;
            this.pendingScrollLoad = false;

            this.$nextTick(() => {
                const el = this.$refs.scrollAnchor;
                if (el && el.scrollIntoView) {
                    el.scrollIntoView({ behavior: "auto", block: "end" });
                }
            });

            if (!this.noMoreItems) {
                this.scheduleNextPrefetch();
            }

            return true;
        },

        onNaoLocalizadoChange(item) {


            if (!item.divergences.naoLocalizado) {
                item.divergences.transferidoParaDeposito = false;
                item.divergences.emApuracao = false;
            }

            item.divergences = {
                naoLocalizado: item.divergences.naoLocalizado,
                emApuracao: item.divergences.emApuracao,
                transferidoParaDeposito: item.divergences.transferidoParaDeposito,
                itemBaixado: false,
                itemOutraLotacao: false,
                solucaoItemBaixado: null,
                solucaoItemOutraLotacao: null,
                departamentoDestino: null,
                localFisicoIncorreto: false,
                solucaoLocalFisicoIncorreto: null,
                localDestino: null,
                conservacaoIncorreta: false,
            };

            this.conservacaoData = {
                pessoa: null,
                tipoEstado: null,
                descricao: "",
                dataAvaliacao: null,
            };

            this.checkDivergencia(item);
        },
        onItemBaixadoChange(item) {
            if (!item.divergences.itemBaixado) {
                item.divergences.solucaoItemBaixado = null;
            }
            this.conservacaoData = {
                pessoa: null,
                tipoEstado: null,
                descricao: "",
                dataAvaliacao: null,
            };

            item.divergences = {
                naoLocalizado: false,
                emApuracao: false,
                transferidoParaDeposito: false,
                itemBaixado: item.divergences.itemBaixado,
                itemOutraLotacao: false,
                solucaoItemBaixado: item.divergences.solucaoItemBaixado,
                solucaoItemOutraLotacao: null,
                departamentoDestino: null,
                localFisicoIncorreto: false,
                solucaoLocalFisicoIncorreto: null,
                localDestino: null,
                conservacaoIncorreta: false,
            };


            this.checkDivergencia(item);
        },
        onItemOutraLotacaoChange(item) {

            if (!item.divergences.itemOutraLotacao) {
                item.divergences.solucaoItemOutraLotacao = null;
                item.divergences.departamentoDestino = null;
            }

            this.conservacaoData = {
                pessoa: null,
                tipoEstado: null,
                descricao: "",
                dataAvaliacao: null,
            };


            item.divergences = {
                naoLocalizado: false,
                emApuracao: false,
                transferidoParaDeposito: false,
                itemBaixado: false,
                itemOutraLotacao: item.divergences.itemOutraLotacao,
                solucaoItemBaixado: null,
                solucaoItemOutraLotacao: item.divergences.solucaoItemOutraLotacao,
                departamentoDestino: null,
                localFisicoIncorreto: false,
                solucaoLocalFisicoIncorreto: null,
                localDestino: null,
                conservacaoIncorreta: false,
            };


            this.checkDivergencia(item);
        },
        onLocalFisicoIncorretoChange(item) {
            if (!item.divergences.localFisicoIncorreto) {
                item.divergences.solucaoLocalFisicoIncorreto = null;
                item.divergences.localDestino = null;
            }

            this.conservacaoData = {
                pessoa: null,
                tipoEstado: null,
                descricao: "",
                dataAvaliacao: null,
            };


            item.divergences = {
                naoLocalizado: false,
                emApuracao: false,
                transferidoParaDeposito: false,
                itemBaixado: false,
                itemOutraLotacao: false,
                solucaoItemBaixado: null,
                solucaoItemOutraLotacao: null,
                departamentoDestino: null,
                localFisicoIncorreto: item.divergences.localFisicoIncorreto,
                solucaoLocalFisicoIncorreto: item.divergences.solucaoLocalFisicoIncorreto,
                localDestino: item.divergences.localDestino,
                conservacaoIncorreta: false,
            };


            this.checkDivergencia(item);
        },
        onConservacaoIncorretaChange(item) {

            this.conservacaoData = {
                pessoa: null,
                tipoEstado: null,
                descricao: "",
                dataAvaliacao: null,
            };


            item.divergences = {
                naoLocalizado: false,
                emApuracao: false,
                transferidoParaDeposito: false,
                itemBaixado: false,
                itemOutraLotacao: false,
                solucaoItemBaixado: null,
                solucaoItemOutraLotacao: null,
                departamentoDestino: null,
                localFisicoIncorreto: false,
                solucaoLocalFisicoIncorreto: null,
                localDestino: null,
                conservacaoIncorreta: item.divergences.conservacaoIncorreta,
            };

            this.checkDivergencia(item);
        },
        showConservacaoModal(item) {
            this.selectedConservacaoItem = item;
            this.mostrarModalConservacao = true;

        },
        openConservacaoModal(item) {
            this.selectedConservacaoItem = item;
            this.mostrarModalConservacao = true;
        },
        openDivergenceSection(item) {
            item.showDivergence = !item.showDivergence;
        },
        async openModal(auditoriaItem = null) {
            if (auditoriaItem) {
                this.resetPaginationState();
                this.itemsTable = [];
                this.form = {
                    id: auditoriaItem.id,
                    dataAuditoria: auditoriaItem.dataAuditoria,
                    codPessoa: auditoriaItem.pessoa && auditoriaItem.pessoa.id ? auditoriaItem.pessoa.id : null,
                    codComissao: auditoriaItem.comissao && auditoriaItem.comissao.id ? auditoriaItem.comissao.id : null,
                    codDepartamento: auditoriaItem.departamento.id,
                    codLocalizacao: auditoriaItem.codLocalizacao,
                    codTipoColetaColetor: auditoriaItem.tipoColetaColetor.id,
                    finalizado: auditoriaItem.finalizado,
                    itens: [],
                };
                this.pessoaComissao = auditoriaItem.pessoa && auditoriaItem.pessoa.id ? auditoriaItem.pessoa : auditoriaItem.comissao;
                this.comissao = auditoriaItem.comissao || null;
                this.responsavel = auditoriaItem.pessoa || null;
                this.departamento = auditoriaItem.departamento || null;
                this.localizacao = auditoriaItem.localizacao || null;


                this.loadItems();
            } else {
                this.isEditing = false;
                this.resetForm();
            }
        },
        onRowSelected(itens) {


            this.itemsTable.forEach(itemParaDescelecionar => {
                itemParaDescelecionar.showDivergence = false;
            })

            if (itens.length == 0)
                return;

            var item = itens[0];

            this.conservacaoData = {
                pessoa: item.divergences.conservacaoData ? item.divergences.conservacaoData.pessoa : null,
                tipoEstado: item.divergences.conservacaoData ? item.divergences.conservacaoData.tipoEstado : null,
                descricao: item.divergences.conservacaoData ? item.divergences.conservacaoData.descricao : null,
                dataAvaliacao: item.divergences.conservacaoData ? item.divergences.conservacaoData.dataAvaliacao : null,
            };

            item.showDivergence = true;

        },
        resetConservacaoData() {
            this.mostrarModalConservacao = false;
            this.selectedConservacaoItem = null;
        }
    },

    async beforeMount() {

        if (this.auditoria && this.auditoria.id) {
            this.busy = true;
            var { data } = await AuditoriaItemBemPermanenteService.buscarPorId(this.auditoria.id);

            this.item = data;
            this.busy = false;
        }


        this.openModal(this.item);

    },
};
</script>

<style scoped>
.row-read-ok {
    background-color: #e6f4ea;
}

.row-read-divergence {
    background-color: #fdecea;
}

.row-unread {
    background-color: #fff3cd;
}

.row-read-ok td,
.row-read-divergence td,
.row-unread td {
    transition: background-color 0.2s ease;
}

.table-container {
    position: relative;
}

.sorting-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.85);
    z-index: 5;
}

.legend {
    gap: 8px;
}

.legend-item {
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 12px;
    color: #063662;
    background-color: #f1f5f9;
    border: 1px solid #d0d8e1;
    margin-right: 8px;
    margin-bottom: 4px;
}

.legend-item.legend-read-ok {
    background-color: #e6f4ea;
    border-color: #b7dfc6;
}

.legend-item.legend-read-divergence {
    background-color: #fdecea;
    border-color: #f5b5ad;
}

.legend-item.legend-unread {
    background-color: #fff3cd;
    border-color: #ffe082;
}
</style>
